export const LOGIN_STATE = {
  UNDETERMINED: 0,
  NOT_LOGGED_IN: 1,
  LOGGED_IN: 2,
};

export default { LOGIN_STATE };
